/**
 * ETP Article Grid – Splide.js initialisation.
 *
 * Breakpoints aligned with SCSS tokens: 601=just-above-bp-xs (600), 900=bp-s.
 *
 * < 900px:   slider active
 * 601–899px: right peek
 * <= 600px:  no peek
 * >= 900px:  destroy Splide, CSS Grid takes over
 */

export function initArticleGridSlider(scope) {
  const roots = (scope || document).querySelectorAll(
    '.etp-article-grid:not([data-etp-ags-ready])'
  );

  const options = {
    type:        'slide',
    perPage:     1,
    perMove:     1,
    gap:         '20px',
    arrows:      false,
    pagination:  true,
    drag:        true,
    mediaQuery:  'min',
    breakpoints: {
      601: { padding: { right: '35%' } },
      900: { destroy: true },
    },
  };

  roots.forEach((root) => {
    if (!window.Splide) {
      console.warn('[ETP article-grid-slider] window.Splide missing.');
      return;
    }

    const splideRoot = root.querySelector('.splide');
    const hasTrack   = !!root.querySelector('.splide__track');
    const hasList    = !!root.querySelector('.splide__list');

    if (!splideRoot || !hasTrack || !hasList) {
      console.warn('[ETP article-grid-slider] skip init, incomplete markup.');
      return;
    }

    try {
      const splide = new window.Splide(splideRoot, options);
      splide.mount();

      // Wire up the custom prev/next buttons that live in .etp-article-grid__header.
      // splide.go('<') moves one slide back; splide.go('>') moves one forward.
      const prevBtn = root.querySelector('.etp-article-grid__arrow--prev');
      const nextBtn = root.querySelector('.etp-article-grid__arrow--next');

      if (prevBtn) prevBtn.addEventListener('click', () => splide.go('<'));
      if (nextBtn) nextBtn.addEventListener('click', () => splide.go('>'));

      // Chrome treats <a> and <img> as natively draggable, which steals the
      // swipe gesture from Splide. draggable="false" is the HTML5-standard
      // opt-out and works cross-browser.
      root.querySelectorAll('.splide__slide a, .splide__slide img')
        .forEach((el) => el.setAttribute('draggable', 'false'));

      root.dataset.etpAgsReady = 'true';
    } catch (err) {
      console.warn('[ETP article-grid-slider] init failed.', err);
    }
  });
}
